import { userHasConsentedToCookieCategoryWithKey } from 'src/cookies/consent-cookie';
import type { BuildType } from 'src/enums/build/build-type';

export const analyticsConsentCookieCategoryKey = 'analytics';

export const userHasConsentedToAnalyticsCookieCategory = (buildType: BuildType): boolean =>
  userHasConsentedToCookieCategoryWithKey(analyticsConsentCookieCategoryKey, buildType);
